import styled from 'styled-components'
import { MONTH_GRID } from '../../constants/constants'

export const StyledMonthPicker = styled.div``

export const Header = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 32px;
`

export const MonthGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(${MONTH_GRID.COLS}, 1fr);
	grid-template-rows: repeat(${MONTH_GRID.ROWS}, 1fr);
	gap: 32px;

	/* Выравнивание по колонкам */
	& > button:nth-child(3n + 1) {
		justify-content: flex-start;
	}

	& > button:nth-child(3n + 2) {
		justify-content: center;
	}

	& > button:nth-child(3n) {
		justify-content: flex-end;
	}
`

interface MonthCellProps {
	$isSelected: boolean
}

export const MonthCell = styled.button<MonthCellProps>`
	background: transparent;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
`
